import React, { Component } from 'react';
import Dropdown from 'react-dropdown';

export default class SmartDrop extends Component {
  measure(dropdownEl) {
    let placeholder = dropdownEl.firstElementChild.firstElementChild;
    let arrow = dropdownEl.firstElementChild.lastElementChild;
    let placeholderRight = placeholder.getBoundingClientRect().right;
    let arrowLeft = arrow.getBoundingClientRect().left;
    if (placeholderRight > arrowLeft) {
      // overlap
      let overlap = placeholderRight - arrowLeft;
      let newWidth = dropdownEl.getBoundingClientRect().width + (overlap * 2) + 40;
      dropdownEl.style.maxWidth = 'none';
      dropdownEl.style.width = `${newWidth}px`;
    } else {
      dropdownEl.style.maxWidth = '400px';
    }
  }
  
  onChange(selected) {
    this.props.onChange(selected);
  
    if (window.innerWidth > 400) {
      setTimeout(() => {
        this.measure(document.querySelector('.Dropdown-root'));
      }, 0);
    }
  }
  
  render() {
    return <Dropdown
            options={this.props.options}
            onChange={this.onChange.bind(this)}
            value={this.props.value} />
  }
  
}



// WEBPACK FOOTER //
// ./app/src/js/lib/Dropdown.js